import { AbcArenaService } from '@barthauer/abc/arena';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { AbcCore, ConvertHelper } from '@barthauer/abc/core';
import { AbcConfigService } from '@barthauer/abc/core/configuration';
import { ResourceManagerService } from '@barthauer/abc/core/resources';
import { MessageBoxService, ProtocolViewerService } from '@barthauer/abc/messages';
import { BceService } from '@barthauer/abc/management/configuration-explorer';
import { BasysArenaComponent, NavigationDocument } from '@barthauer/basys/arena';
import { AppService } from './app.service';
import { Router } from '@angular/router';
import { DataService } from './services/data.service';
import { OperaManagerPlugin } from './plugins';
import { AbcContainerService } from '../../../../../libs/abc/ui-components/src';
import { WorkService } from '../../../../../libs/basys/opera/wizards/src';
import { NotificationsService } from '../../../../../libs/abc/core';

@Component({
  selector: 'basys-opera-manager-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit, OnDestroy {
  private basysArenaCpt: BasysArenaComponent;

  constructor(
    private appService: AppService,
    private abcArenaService: AbcArenaService,
    private core: AbcCore,
    private configService: AbcConfigService,
    private messageBoxService: MessageBoxService,
    private resourceService: ResourceManagerService,
    private protocolService: ProtocolViewerService,
    private router: Router,
    private dataService: DataService,
    private bceService: BceService,
    private abcContainer: AbcContainerService,
    private workService: WorkService,
    private notificationsService: NotificationsService,
  ) {
    this.appService.resAsync = this.resourceService.getResourceSet('opera-manager');
  }

  async ngOnInit() {
    this.appService.res = await this.appService.resAsync;

    if (!(window as any).__bfcacheHandlerAttached) {
      (window as any).__bfcacheHandlerAttached = true;

      window.addEventListener('pageshow', (e: PageTransitionEvent) => {
        if (e.persisted) {
          const panel = document.querySelector('.dx-drawer-panel-content') as HTMLElement | null;
          if (panel) {
            panel.style.removeProperty('display');
          }
        }
      });
    }
  }

  ngOnDestroy(): void {}

  public async loadNavigationDocument(component) {
    this.abcArenaService.prepareNavigationDocument = async (navDoc: NavigationDocument) => {
      if (!navDoc?.Groups) {
        return;
      }
      for (const grp of navDoc.Groups) {
        if (grp.Name === 'Ticketverwaltung' && !(await this.hasMtTicketsLicense())) {
          grp.VisibleIndex = -1;
          grp.IsVisible = false;
        }
      }
    };

    if (component instanceof BasysArenaComponent) {
      this.basysArenaCpt = component;
      this.basysArenaCpt.beforeLogoutFunc = () => {
        const routes = this.router.config;
        for (let index = 0; index < routes.length; index++) {
          const route = routes[index];

          if (route.outlet === 'mainOutlet' && route?.data?.MarkerTag === 'Map') {
            routes[index].path = 'Map';
            break;
          }
        }
      };

      this.appService.configureRouter();

      this.basysArenaCpt.renderDataForm = true;
      this.basysArenaCpt.renderHigna = true;
      this.basysArenaCpt.renderHigon = true;
      this.basysArenaCpt.renderMenu = true;
      this.basysArenaCpt.renderNavigation = true;
      this.basysArenaCpt.renderHeader = true;
      this.basysArenaCpt.renderDrawer = true;

      const pl = new OperaManagerPlugin(
        {
          core: this.core,
          messageBoxService: this.messageBoxService,
          protocolService: this.protocolService,
          abcArenaService: this.abcArenaService,
          appService: this.appService,
          dataService: this.dataService,
          bceService: this.bceService,
          basysArenaCpt: this.basysArenaCpt,
          abcContainer: this.abcContainer,
          workService: this.workService,
        },
        this.notificationsService,
      );

      await pl.init();

      this.basysArenaCpt.plugins = [pl];

      this.basysArenaCpt.helpUrl = 'http://help.barthauer.de/BaSYS/9.26.1/Web/opera-manager/#t=02_BaSYS%2FA_BaSYS.htm';
    }
  }

  private hasTicketLicense: boolean | undefined = undefined;
  private async hasMtTicketsLicense(): Promise<boolean> {
    if (this.hasTicketLicense === undefined) {
      try {
        const licenses = ConvertHelper.arrayBufferToObjectArray(
          await this.core.data
            .checkLicenses({
              Features: [
                { AppIdentifier: this.configService.configuration.ApplicationIdentifier, FeatureName: 'Tickets' },
              ],
            })
            .toPromise(),
        );
        this.hasTicketLicense = licenses?.length === 1 && ConvertHelper.toBoolean(licenses[0]['IsAvailable']);
      } catch (err) {
        console.log(err); //console.log only, because of support for older WebApi
      }
    }
    return this.hasTicketLicense;
  }
}
